import { render, staticRenderFns } from "./bom.vue?vue&type=template&id=499e70b9&scoped=true&"
import script from "./bom.vue?vue&type=script&lang=js&"
export * from "./bom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e70b9",
  null
  
)

export default component.exports